<template>
  <div class="col-3-center">
    <p>
      Der Vorentwurf der Leitbilder entstand auf Basis der
      Ergebnisse aus den Arbeitsgruppensitzungen vom
      30.4. und 22.5.2019 und wurde mit den Ergebnissen aus der Online-Beteiligung der interaktiven Karte
      abgeglichen.
    </p>
    <!-- <p>
      Die hieraus entwickelten Leitgedanken sind acht Themenfeldern zugeordnet: Flanier-, Natur-, Heimat-,
      Kompakt-, Kultur-, Quartier-, Unternehmer- und Teilhabe-Stadt.
    </p>-->

    <p>
      Die Dokumentation zum Download als PDF finden Sie
      <router-link to="/projekt/downloads">hier</router-link>.
    </p>
    <img :src="require('@/assets/fotos/onlineumfrage/onlineumfrage.png')" alt="onlineumfrage" />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Online Umfrage"
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>